import { createFileRoute } from '@tanstack/react-router'

import { GlobalRoleType } from '@beaded/models'

import { requireGlobalRole } from 'lib/routeGuards'

import PageEditor from 'pages/PageAdmin/PageEditor'

export const Route = createFileRoute(
  '/_auth/_global/page-admin/$pageType/$idOrSlug',
)({
  beforeLoad: requireGlobalRole(GlobalRoleType.GLOBAL_ADMIN),
  component: PageEditor,
})
